export const ZONE_FIRST = 'ZONE_FIRST'
export const ZONE_SECOND = 'ZONE_SECOND'
export const ASIA_CALCUTTA = 'Asia/Calcutta'
export const EMPTY_STRING = ''
export const WEBSITE_NAME = '1clock'
export const WEBSITE_META_NAME = 'Your Global Time Hub with 3D Globe Visualization'
export const WEBSITE_DESCRIPTION = '1clock, a sleek clock website featuring customizable digital and analog clocks. Immerse yourself in a 3D globe, effortlessly exploring time zones by clicking on any country. Experience the art of timekeeping with the visually captivating design. Your go-to for an innovative and aesthetic clock experience!'
export const WEBSITE_DESIGNED_BY = 'Debraj Karmakar'
export const LINKEDIN_URL = 'https://www.linkedin.com/in/debrajkarmakar010/'
export const GITHUB_URL = 'https://github.com/debrajhyper/1clock'
export const X_URL = 'https://twitter.com/debraj_010/status/1738619052397039635'
export const DIGITAL = 'Digital'
export const ANALOG = 'Analog'
export const AM = 'AM'
export const PM = 'PM'
export const EN_US = 'en-US'
export const COLON_SEPARATOR = ':'
export const UNDERSCORE_SEPARATOR = '_'
export const EMPTY_SEPARATOR = ' '
export const NO_OF_DIGITS = '2-digit'
export const WINDOW_RESIZE = 'resize'
export const GRID_CHANGE_ON_MOBILE = '(max-width: 640px)'